import styles from './Textarea.module.scss';

export const TextareaModifiers = {
    WithoutBottomLine: styles.withoutBottomLine,
    TransparentBottomOnView: styles.transparentBottomOnView,
    Dictating: styles.dictating,
};
